export const passwordAlert = "Your password must be at least 8 characters long, should contain at least 1 uppercase, 1 lowercase, 1 numeric and 1 special character.";


// WEBPACK FOOTER //
// src/helpers/alertText.js